import { ConnectionUtils } from "@inter-ikea-core/core";
const removeUnvalidEntities = (services, entity) => {
    const collisionResult = services.validations.validateCurrentState(entity);
    collisionResult.map((item) => {
        if (item) {
            ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(item.entity);
        }
    });
};
export default removeUnvalidEntities;
